import {
  FETCH_USAGE_LOCATIONS_REQUEST,
  FETCH_USAGE_LOCATIONS_SUCCESS,
  FETCH_USAGE_LOCATIONS_FAILURE,
} from "../actions/usageLocationAction";

const initialState = {
  locations: [],
  loading: false,
  error: null,
};

const usageLocationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USAGE_LOCATIONS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_USAGE_LOCATIONS_SUCCESS:
      return { ...state, loading: false, locations: action.payload };

    case FETCH_USAGE_LOCATIONS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default usageLocationReducer;
